export default {
  brand: {
    name: 'USFansLink',
    tagline: 'Spreadsheet Resource Hub',
  },
  nav: {
    home: 'Home',
    shoppingGuide: 'Shopping Guide',
    articles: 'Articles',
    qc: 'QC Guide',
    shipping: 'Shipping',
    faq: 'FAQ',
    browse: 'Browse Categories',
  },
  buttons: {
    buyNow: 'Buy It Now',
    explore: 'Explore USFans Spreadsheet',
    browseGuides: 'Browse Product Guides',
    readMore: 'Read the guide',
    backHome: 'Back to Home',
    viewAll: 'View all categories',
    continue: 'Continue to the Main Website',
  },
  footer: {
    about: 'USFansLink.site is an independent informational resource for the USFans Spreadsheet. We help shoppers find product links, QC information, shipping guides and safe buying tips.',
    quickLinks: 'Quick Links',
    categories: 'Categories',
    resources: 'Resources',
    language: 'Language',
    disclaimer: 'Disclaimer: External links, products, prices, shipping information and promotions may change. Always verify current information before making a purchase or payment.',
    copyright: 'All rights reserved.',
  },
};